import { useParams } from 'react-router-dom'

import { AdminTimeTrackingDashboard } from '@/features/time-tracking'

export default function NetworkTimeTracking() {
  const { networkId } = useParams()

  if (!networkId) return null

  return <AdminTimeTrackingDashboard networkId={networkId} />
}
